// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3_42P","messages":"Chat_messages__3bmN6","dateDivider":"Chat_dateDivider__3_ZG1"};